module.exports = __webpack_public_path__ + "img/SketchPnge2f67535b2032e19741e9efa4590eb62ebaff2e27c14828b99ee8abdbf5bc6f7.506c081e.png";